/* Copyright 2020 cpke
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by cpke <cryptio@pm.me>, December 2020
 */

import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faPlus } from "@fortawesome/free-solid-svg-icons";
import BTable from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import Alert from "react-bootstrap/Alert";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import { useTable } from "react-table";
import "./Users.css";
import { httpClient } from "../../request";
import { statusToIcon } from "../../status";
import { epochToDate } from "../../dateutils";

/**
 * @todo Support pagination
 *
 * @param {*} param0
 */
function Table({ columns, data }) {
  // Use the state and functions returned from useTable to build your UI
  const { getTableProps, headerGroups, rows, prepareRow } = useTable({
    columns,
    data,
  });

  // Render the UI for your table
  return (
    <BTable striped bordered hover size="sm" {...getTableProps()}>
      <thead>
        {headerGroups.map((headerGroup) => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column) => (
              <th {...column.getHeaderProps()}>{column.render("Header")}</th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody>
        {rows.map((row, i) => {
          prepareRow(row);
          return (
            <tr {...row.getRowProps()}>
              {row.cells.map((cell) => {
                return <td {...cell.getCellProps()}>{cell.render("Cell")}</td>;
              })}
            </tr>
          );
        })}
      </tbody>
    </BTable>
  );
}

/**
 * @todo: Add ability to add/edit/delete users
 */
export default function Keys() {
  const [isLoading, setLoading] = useState(true);
  const [apps, setApps] = useState([]);
  const [appIDIndex, setAppIDIndex] = useState(-1);
  const [result, setResult] = useState(false);

  const [createShow, setCreateShow] = useState(false);

  const handleCreateClose = () => setCreateShow(false);
  const handleCreateShow = () => setCreateShow(true);

  const [createData, setCreateData] = useState({
    apiKey: "",
    expiry: 0,
    permission: 0,
    notes: "",
  });

  const handleCreateChange = (e) => {
    const { id, value } = e.target;
    setCreateData((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleCreateChangeDatetime = (id, m) => {
    setCreateData((prevState) => ({
      ...prevState,
      [id]: m.valueOf() / 1000,
    }));
  };

  const token = JSON.parse(localStorage.getItem("token"));

  const handleChangeAppID = (e) => {
    const { id, value } = e.target;
    setAppIDIndex(value);
  };

  const getApps = () => {
    httpClient
      .get("/private/apps", {
        headers: {
          Authorization: "Bearer " + token.token,
        },
      })
      .then((response) => {
        const responseData = response.data;

        let appsForId = responseData.apps;

        if (appsForId) {
          for (let i = 0; i < appsForId.length; ++i) {
            for (let j = 0; j < appsForId[i].ApiKeys.length; ++j) {
              appsForId[i].ApiKeys[j].app = appsForId[i].PublicId;
            }
          }

          setApps(appsForId);
        } else {
          setApps([]);
        }

        setLoading(false);
      })
      .catch((error) => {
        // The error has response, it likely has an error message from the API
        if (error.response) {
          const responseData = error.response.data;
          if ("error" in responseData) {
            /* Additionally clear the input fields if we fail to login. The form will still show the text, but the email and password state values will be
             * empty, leading to a confusing error due to the app not sending any credentials in a subsequent request
             */
            setResult({
              status: "danger",
              message: responseData.error,
            });
          }
        } else {
          // Catch edge cases, usually happens with network errors
          setResult({
            status: "danger",
            message: error.message,
          });
        }
      });
  };

  const createKey = () => {
    httpClient
      .post(`/private/apiKeys?app=${apps[appIDIndex].PublicId}`, null, {
        headers: {
          Authorization: "Bearer " + token.token,
        },
        params: createData,
      })
      .then((response) => {
        const responseData = response.data;

        if (responseData.status === true) {
          setResult({
            status: "success",
            message: "Successfully created new API key",
          });

          getApps();
        } else {
          setResult({
            status: "danger",
            message: "An unknown error has occurred",
          });
        }
      })
      .catch((error) => {
        // The error has response, it likely has an error message from the API
        if (error.response) {
          const responseData = error.response.data;
          if ("error" in responseData) {
            /* Additionally clear the input fields if we fail to login. The form will still show the text, but the email and password state values will be
             * empty, leading to a confusing error due to the app not sending any credentials in a subsequent request
             */
            setResult({
              status: "danger",
              message: responseData.error,
            });
          }
        } else {
          // Catch edge cases, usually happens with network errors
          setResult({
            status: "danger",
            message: error.message,
          });
        }
      });

    setCreateShow(false);
  };

  const deleteKey = (key, appID) => {
    console.log("id", appID);
    console.log("apps", apps);

    httpClient
      .delete(`/private/apiKeys?app=${appID}&apiKey=${key}`, {
        headers: {
          Authorization: "Bearer " + token.token,
        },
      })
      .then((response) => {
        setResult({
          status: "success",
          message: "Deleted key",
        });

        // Reload the users since our data changed
        getApps();
      })
      .catch((error) => {
        // The error has response, it likely has an error message from the API
        if (error.response) {
          const responseData = error.response.data;
          if ("error" in responseData) {
            /* Additionally clear the input fields if we fail to login. The form will still show the text, but the email and password state values will be
             * empty, leading to a confusing error due to the app not sending any credentials in a subsequent request
             */
            setResult({
              status: "danger",
              message: responseData.error,
            });
          }
        } else {
          // Catch edge cases, usually happens with network errors
          setResult({
            status: "danger",
            message: error.message,
          });
        }
      });
  };

  // useEffect tells the component that it must do something after it has rendered
  useEffect(() => getApps(), []);

  const columns = React.useMemo(
    () => [
      {
        Header: "API Keys",
        columns: [
          {
            Header: "Keys",
            accessor: "Key",
          },
          {
            Header: "Expires At",
            accessor: (d) => {
              return d.Expiry ? epochToDate(d.Expiry).toISOString() : "N/A";
            },
          },
          {
            Header: "Permission",
            accessor: "Permission",
          },
          {
            Header: "Notes",
            accessor: "Notes",
          },
          {
            id: "del",
            Header: "",
            accessor: (d) => {
              return d;
            },
            Cell: ({ value }) => (
              <Button
                variant="danger"
                onClick={() => {
                  deleteKey(value.Key, value.app);
                }}
              >
                <FontAwesomeIcon icon={faTrash} />
              </Button>
            ),
          },
        ],
      },
    ],
    []
  );

  return (
    <div className="Users">
      <div className="mt-5">
        {result && (
          <Alert variant={result.status}>
            <span className="mr-1">
              <FontAwesomeIcon icon={statusToIcon[result.status]} />
            </span>
            <span>{result.message}</span>
          </Alert>
        )}

        {isLoading ? (
          <div>Loading...</div>
        ) : (
          <div>
            <Form>
              <Form.Group controlId="appID">
                <Form.Label>App ID</Form.Label>
                <Form.Control
                  as="select"
                  onChange={handleChangeAppID}
                  defaultValue={`DEFAULT`}
                >
                  <option value="DEFAULT" disabled>
                    Select an app ID...
                  </option>
                  {apps.map((c, i) => {
                    return (
                      <option key={c.PublicId} value={i}>
                        {c.PublicId}
                      </option>
                    );
                  })}
                </Form.Control>
                <small className="form-text text-muted">
                  Select an app to show its API keys
                </small>
              </Form.Group>
            </Form>

            <div>
              {appIDIndex >= 0 && (
                <div>
                  <Table columns={columns} data={apps[appIDIndex].ApiKeys} />
                  {(apps[appIDIndex].ApiKeys === null || apps[appIDIndex].ApiKeys.length === 0) && (
                    <p className="text-center">No data available</p>
                  )}
                </div>
              )}

              <div className="float-right">
                <Button variant="success" onClick={handleCreateShow}>
                  <FontAwesomeIcon icon={faPlus} />
                </Button>
              </div>

              <Modal show={createShow} onHide={handleCreateClose}>
                <Modal.Header closeButton>
                  <Modal.Title>Add API key</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                  <Form>
                    <Form.Group controlId="apiKey">
                      <Form.Label>API Key</Form.Label>
                      <Form.Control
                        type="text"
                        value={createData.username}
                        onChange={handleCreateChange}
                      />
                    </Form.Group>

                    <Form.Group controlId="expiry">
                      <Form.Label>Expires At</Form.Label>
                      <Datetime
                        value={epochToDate(createData.expiry).toLocaleString()}
                        onChange={(value) => {
                          handleCreateChangeDatetime("expiry", value);
                        }}
                      />
                    </Form.Group>

                    <Form.Group controlId="permission">
                      <Form.Label>Permission</Form.Label>
                      <Form.Control
                        type="text"
                        value={createData.permission}
                        onChange={handleCreateChange}
                      />
                    </Form.Group>

                    <Form.Group controlId="notes">
                      <Form.Label>Notes</Form.Label>
                      <Form.Control
                        type="text"
                        value={createData.notes}
                        onChange={handleCreateChange}
                      />
                    </Form.Group>
                  </Form>
                </Modal.Body>

                <Modal.Footer>
                  <Button variant="secondary" onClick={handleCreateClose}>
                    Cancel
                  </Button>

                  <Button variant="primary" onClick={createKey}>
                    Save Changes
                  </Button>
                </Modal.Footer>
              </Modal>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/containers/dashboard/Keys.js